import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    containerWrapper: {
        width: '100%',
        backgroundColor: theme.palette.bg.blue,
        backgroundImage: "url('https://res.cloudinary.com/studentbe/image/upload/v1721138136/student-be-assets/Mask_group.png')"
    }
}))
